import { PosReports } from './PosReports';
export default PosReports;